import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNecklaceMen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.5 4.48963C21.5 3.07884 20.4266 2 19.023 2H4.98663C4.49123 2 3.99582 2.16598 3.58299 2.41494C2.42705 3.24481 2.17935 4.73859 2.92245 5.90041L10.8489 17.6017H10.7663C10.436 17.6017 10.1883 17.8506 10.1883 18.2656V21.4191C10.1883 21.751 10.436 22 10.8489 22H13.3259C13.6561 22 13.9038 21.751 13.9038 21.3361V18.1826C13.9038 17.8506 13.6561 17.6017 13.2433 17.6017H13.1607L21.0872 5.90041C21.3349 5.48548 21.5 4.98755 21.5 4.48963ZM12.5828 20.6722H11.3443V18.8465H12.5828V20.6722ZM20.0138 5.15353L12.0048 17.1037L3.99582 5.15353C3.83069 4.98755 3.74812 4.73859 3.74812 4.48963C3.74812 3.82573 4.32609 3.24481 4.98663 3.24481H19.023C19.2707 3.24481 19.5184 3.3278 19.6835 3.49378C20.2615 3.82573 20.4266 4.6556 20.0138 5.15353Z",
		fill: "currentColor"
	})
});
export default SvgNecklaceMen;
